import { render, staticRenderFns } from "./ShelvedTable.vue?vue&type=template&id=32baa13b&"
import script from "./ShelvedTable.vue?vue&type=script&lang=js&"
export * from "./ShelvedTable.vue?vue&type=script&lang=js&"
import style0 from "./ShelvedTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports